"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AddOnUnitType;
(function (AddOnUnitType) {
    AddOnUnitType["PER_TRIP"] = "per trip";
    AddOnUnitType["PER_HOUR"] = "per hour";
    AddOnUnitType["PER_PERSON"] = "per person";
})(AddOnUnitType = exports.AddOnUnitType || (exports.AddOnUnitType = {}));
var RequiredAddOnUnitType;
(function (RequiredAddOnUnitType) {
    RequiredAddOnUnitType["PER_PERSON_ABOVE_LIMIT"] = "per person above limit";
})(RequiredAddOnUnitType = exports.RequiredAddOnUnitType || (exports.RequiredAddOnUnitType = {}));
var DefinedAddOnType;
(function (DefinedAddOnType) {
    DefinedAddOnType["EXTRA_GUEST_FEE"] = "extra guest fee";
})(DefinedAddOnType = exports.DefinedAddOnType || (exports.DefinedAddOnType = {}));
